import makeStyles from '@mui/styles/makeStyles';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import CardOrderedImage from 'images/signups/card/card-ordered-success.png';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkButton from 'react/shared/components/true_link/main/TrueLinkButton';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';
import theme from 'react/shared/theme/Theme';
import { possessiverize } from 'react/shared/utils/Strings';
import { USER_TYPES } from 'react/signups/card/recipes/constants';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
  },
  card: {
    marginBottom: theme.spacing(5),
  },
  img: {
    height: '300px',
    marginBottom: theme.spacing(5),
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  skipBtn: {
    marginTop: '20px',
  },
}));

export default function Success({ account, firstName, onComplete, userType }) {
  const classes = useStyles();
  const shipping_range = account.cardEstimatedArrivalHash?.range || '';
  // eslint-disable-next-line compat/compat, no-undef
  const early = new URLSearchParams(window.location.search).get('early');
  const isClient = userType === USER_TYPES.CLIENT;

  const connectBankAccount = () => {
    Cookies.set('connect_bank_modal', true, { expires: 1 / 1440 }); // 1 minute is 1/1440 of a day
    onComplete();
  };

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <img alt="Card ordered successfully" className={classes.img} src={CardOrderedImage} />
        {early ? (
          <>
            <CardHeader>Great, our Account Management team will be in touch!</CardHeader>
            <CardText>
              We'll help you order all of your cards in one seamless process.
              <br />
              <br />
              You can then set up the cards by connecting a bank and setting up the spending
              settings from your True Link dashboard.
            </CardText>
          </>
        ) : (
          <>
            <CardHeader>Great, {possessiverize(firstName)} card has been ordered!</CardHeader>
            <CardText>
              Cards typically arrive within {shipping_range[0]}-{shipping_range[1]} business days.
              <br />
              <br />
              In the meantime,{' '}
              {isClient
                ? 'connect a bank account and set up the Spending Settings from your True Link dashboard.'
                : 'let’s start the process of getting funds on the card.'}
            </CardText>
          </>
        )}
      </div>
      {isClient && (
        <TrueLinkButton onClick={onComplete} size="large" variant="primary">
          {early ? 'Go to dashboard' : 'Finish setting up card'}
        </TrueLinkButton>
      )}
      {!isClient && (
        <div className={classes.footer}>
          <TrueLinkButton onClick={connectBankAccount} size="large" variant="primary">
            Connect a bank account
          </TrueLinkButton>
          <TrueLinkLink className={classes.skipBtn} onClick={onComplete}>
            Skip for now
          </TrueLinkLink>
        </div>
      )}
    </div>
  );
}

Success.propTypes = {
  account: PropTypes.object.isRequired,
  firstName: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired,
};
